'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformODataResponse = exports.getQuery = exports.getLimitOptions = undefined;

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getLimitOptions = exports.getLimitOptions = function getLimitOptions() {
  return [5, 10, 25, 50, 100];
};
var getQuery = exports.getQuery = function getQuery() {
  return _angular2.default.copy({
    take: 10,
    page: 1,
    calculateSkip: function calculateSkip() {
      return this.take * (this.page - 1);
    }
  });
};

var transformODataResponse = exports.transformODataResponse = function transformODataResponse(r) {
  return {
    Count: r.data['@odata.count'],
    Data: r.data.value
  };
};


// WEBPACK FOOTER //
// ./common/utilities/query.js